import type { TGetSimulacaoResponse } from '@/features/simulacao/interfaces/simulacao.type'
import { HttpService } from '@/shared/lib/http'

export class GetSimulacaoPorId extends HttpService {
  execute = async (simulacaoId: string) => {
    return this.http.get<TGetSimulacaoResponse>(`/api/v2/Simulacao/${simulacaoId}`)
  }
}
